import { Experiences } from '@luxuryescapes/contract-svc-experience';

import {
  EXP_PROVIDER_ASPIRE,
  EXP_PROVIDER_CUSTOMLINC,
  EXP_PROVIDER_DERBYSOFT,
  EXP_PROVIDER_KLOOK,
  EXP_PROVIDER_REZDY,
} from '~/consts/experiences/providers';

const BLOCKED_PROVIDERS: ReadonlyArray<Experiences.Provider> = [
  EXP_PROVIDER_REZDY,
  EXP_PROVIDER_DERBYSOFT,
  EXP_PROVIDER_KLOOK,
  EXP_PROVIDER_ASPIRE,
  EXP_PROVIDER_CUSTOMLINC,
];

interface Options {
  provider: Experiences.Provider;
  areOriginalValues: boolean;
  transferEnabled: boolean;
}

export function canEnableBuyNowBookLater({ provider, areOriginalValues, transferEnabled }: Options): boolean {
  return !areOriginalValues && !transferEnabled && !BLOCKED_PROVIDERS.includes(provider);
}
